module.exports = __webpack_public_path__ + "static/construction-f4fc67ec0593a5da7a161af5c8f8ab93.jpg";